const ExpensesListMapComponent = ({ name, value, Setfunction, HighlightData }) => {
  console.log(value);
  return (
    <>
      <div className="AvailableExpenseList">
        <p className="Expense_Heading">{name}</p>
        <div className="AvailableExpenseList_subdiv">
          {value &&
            value?.length > 0 &&
            value?.map((el, i) => {
              console.log(el);
              return (
                <p
                  onClick={() => Setfunction(i, el)}
                  key={i}
                  style={{
                    backgroundColor: HighlightData?._id === el._id ? "#CCCCCC" : "",
                  }}
                >
                  {el.Name || el.Page_Name || el.Field_Title || el.Field_Label}
                </p>
              );
            })}
        </div>
      </div>
    </>
  );
};

export default ExpensesListMapComponent;
